import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Settings.css';

const api = axios.create({
  baseURL: '/api'
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const Settings = () => {
  const [activeTemplate, setActiveTemplate] = useState('template2');
  const [message, setMessage] = useState('');

  useEffect(() => {
    enforceClassicTemplate();
  }, []);

  const enforceClassicTemplate = async () => {
    try {
      await api.put('/settings/active_template', { value: 'template2' });
      setActiveTemplate('template2');
      setMessage('Classic Alpine template locked successfully.');
    } catch (error) {
      console.error('Failed to enforce Classic Alpine template:', error);
      setMessage('Failed to lock template in database, but frontend is still using Classic Alpine.');
    }
  };

  const templates = [
    {
      id: 'template2',
      name: 'Classic Alpine (Active)',
      description: 'Traditional layout inspired by alpenjaeger.de with image selector and clean sections. Modern Glass has been removed.',
      preview: '/template-previews/template2.jpg',
      features: ['Top image selector', 'Simple language switcher', 'Clean card layout', 'Professional contact section']
    }
  ];

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h2>Website Settings</h2>
        <p>Classic Alpine is the only active website template</p>
      </div>

      <div className="settings-section">
        <h3>Active Template</h3>
        
        <div className="templates-grid">
          {templates.map((template) => (
            <div
              key={template.id}
              className={`template-card ${activeTemplate === template.id ? 'selected' : ''}`}
            >
              <div className="template-preview">
                <div className="template-preview-placeholder">
                  <span className="template-icon">🎨</span>
                  <p>Preview</p>
                </div>
              </div>
              
              <div className="template-info">
                <h4>{template.name}</h4>
                <p className="template-description">{template.description}</p>
                
                <ul className="template-features">
                  {template.features.map((feature, index) => (
                    <li key={index}>✓ {feature}</li>
                  ))}
                </ul>

                <button
                  className={`template-select-btn ${activeTemplate === template.id ? 'selected' : ''}`}
                  type="button"
                  disabled
                >
                  Active
                </button>
              </div>
            </div>
          ))}
        </div>

        {message && (
          <div className={`settings-message ${message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings;
